module.exports = __webpack_public_path__ + "static/media/home-w.631c3239.svg";